import * as authEvents from "../../store/events/auth";
import * as profileEvents from "../../store/events/profile";
import Box from "@mui/material/Box";
import Button from "../Button/Button";
import { Form } from "@pheaa/channels-component-library";
import FormTextField from "../Form/FormTextField";
import ProfileErrorMessages from "../ErrorMessages/ProfileErrorMessages";
import React from "react";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import {
	HTML_ATTR_PATTERN_DOB,
	HTML_ATTR_PATTERN_NAME_LAST,
	HTML_ATTR_PATTERN_SSN_ACCOUNT_NO,
	INTERFACE_ERROR_MESSAGE_REG
} from "../../config/common";

const AccountLinkForm = props => {

	const {
		createProfile,
		endSession,
		isCreatingProfile,
		isPendingSessionEnd
	} = props;

	const handleSubmit = (e, formData) => {
		createProfile(formData);
	};

	return (
		<React.Fragment>
			<Typography paragraph={true}>Enter additional information:</Typography>
			<Form
				id="defaultFormNarrow"
				onSubmit={handleSubmit}
			>
				<ProfileErrorMessages customSystemErrors={{ 400: { message: INTERFACE_ERROR_MESSAGE_REG } }} />
				<FormTextField
					inputStyle="cmp-form-text--cognito"
					name="accountIdentifier"
					pattern={HTML_ATTR_PATTERN_SSN_ACCOUNT_NO}
					placeholder="Account Number or SSN"
					required={true}
					title="Account Number or SSN"
				/>
				<FormTextField
					inputStyle="cmp-form-text--cognito"
					name="lastName"
					pattern={HTML_ATTR_PATTERN_NAME_LAST}
					placeholder="Last Name"
					required={true}
					title="Last Name"
				/>
				<FormTextField
					inputStyle="cmp-form-text--cognito"
					name="dateOfBirth"
					pattern={HTML_ATTR_PATTERN_DOB}
					placeholder="MM/DD/YYYY"
					required={true}
					title="Date of Birth"
				/>
				<Box mt={5.625}>
					<Button
						disabled={isCreatingProfile || isPendingSessionEnd}
						processing={isCreatingProfile}
						type="submit"
						variant="contained"
					>
						Continue
					</Button>
					<Box mt={1.75}>
						<Button
							disabled={isPendingSessionEnd}
							onClick={() => { endSession(); }}
							processing={isPendingSessionEnd}
							size="small"
						>
							Sign Out
						</Button>
					</Box>
				</Box>
			</Form>
		</React.Fragment>
	);
};

const mapStateToProps = state => ({
	isCreatingProfile: state.profile.isCreating,
	isPendingSessionEnd: state.auth.isPendingSessionEnd
});

const mapDispatchToProps = dispatch => ({
	endSession: data => dispatch(authEvents.endSession(data)),
	createProfile: data => dispatch(profileEvents.createProfile(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkForm);